import orders_service from '../../services/orders'
import base from '../../services/base'

# initial state - just holds response data
state = =>
  all: []
  pagination: null
  loading: false
  timeout_id: null
  polling: false
  updated_at: ''
  pending_carter_count: 0
  shipping_statuses: []

actions =
  fetch_shipping_statuses: ({ commit, state }) ->
    return if state.shipping_statuses.length
    base.fetch('/orders/statuses').then (statuses) -> commit 'shipping_statuses', statuses if statuses

  fetch: ({ commit, dispatch, state }, params = {}) ->
    commit 'loading', true
    orders_service.fetch_orders params, (response) =>
      commit 'set_orders', response.orders
      commit 'set_pagination', response.pagination
      commit 'updated_at', new Date().toISOString()
      commit 'loading', false
      commit 'pending_carter_count', response.pending_carter_count
      clearTimeout(state.timeout_id) if state.timeout_id
      dispatch('poll', params) if state.polling

  poll: ({ commit, dispatch, state }, params = {}) ->
    commit 'timeout_id', setTimeout =>
      dispatch 'fetch', params
    , 60000

  start_polling: ({ commit }) ->
    commit 'polling', true

  stop_polling: ({ commit, state }) ->
    commit 'polling', false
    clearTimeout(state.timeout_id) if state.timeout_id

mutations =
  shipping_statuses: (state, statuses) ->
    state.shipping_statuses = statuses

  set_orders: (state, orders) ->
    state.all = orders

  set_pagination: (state, pagination) ->
    state.pagination = pagination

  loading: (state, loading) ->
    state.loading = loading

  polling: (state, polling) ->
    state.polling = polling

  timeout_id: (state, timeout_id) ->
    state.timeout_id = timeout_id

  updated_at: (state, time) ->
    state.updated_at = time

  pending_carter_count: (state, count) ->
    state.pending_carter_count = count

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
